import React, { useState } from 'react';
import _MaskedInput from 'react-text-mask';
import TextField from '@mui/material/TextField';
import _emailMask from 'text-mask-addons/dist/emailMask';

const MaskedInput = _MaskedInput.default ?? _MaskedInput;
const emailMask = (_emailMask.default ?? _emailMask).mask;
const emailPipe = (_emailMask.default ?? _emailMask).pipe;

function EmailMaskedTextField({
  inputRef,
  validCallback,
  onKeyPress,
  onBlur,
  errorText,
  ...props
}) {
  const [value, setValue] = useState();
  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    validCallback(re.test(String(email).toLowerCase()));
  };

  const handleOnBlur = (e) => {
    setValue(e.target.value);
    validateEmail(e.target.value);
    if (onBlur) {
      onBlur(e.target.value);
    }
    if (onKeyPress) {
      onKeyPress(e);
    }
  };

  const EmailTextMask = React.forwardRef((props, ref) => {
    const { placeholder, onBlur, onKeyPress, ...other } = props;
    return (
      <MaskedInput
        {...other}
        defaultValue={value}
        onBlur={(e) => handleOnBlur(e)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleOnBlur(e);
          }
        }}
        ref={ref}
        placeholder={placeholder ? placeholder : 'Email Address'}
        mask={emailMask}
        pipe={emailPipe}
        showMask
      />
    );
  });
  return (
    <TextField
      inputRef={inputRef}
      errorText={errorText}
      {...props}
      InputProps={{
        inputComponent: EmailTextMask,
        value: value,
      }}
    />
  );
}

export { EmailMaskedTextField };
